let _ = require('lodash');
let { URI, Query } = require('catberry-uri');

function patchQuery (location, params) {
    if (params) {
        var uri = new URI(location);

        if (!uri.query) {
            uri.query = new Query();
        }
        if (!uri.query.values) {
            uri.query.values = {};
        }

        _.forEach(params, (value, key) => {
            uri.query.values[key] = value;
        });

        return uri.toString();
    }

    return location;
}

module.exports = {
    /**
     * Cut css composes classes and add '.' to string
     * @param {String} string
     * @returns {String}
     */
    cut: function (string) {
        var firstClass = _.first(string.split(' '));
        return '.' + firstClass;
    },

    pluralize: function (number, textForms) {
        let n = Math.abs(number) % 100;
        let n1 = n % 10;

        if (n > 10 && n < 20) {
            return textForms[2];
        }

        if (n1 > 1 && n1 < 5) {
            return textForms[1];
        }

        if (n1 == 1) {
            return textForms[0];
        }

        return textForms[2];
    },

    patchQuery,

    patchQueryWithUtm (location, state) {
        var utm = state.get('utm');

        return patchQuery(location, utm);
    }
};



// WEBPACK FOOTER //
// ./helpers/utils.js